import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JhiAlertService, JhiDataUtils, JhiEventManager } from 'ng-jhipster';

import { Faculty } from '../../../models';
import { FacultyService } from '../../../services';
import { AlertUtils, FileUtils, ParamUtils } from '../../../shared';
import { FACULTY_LIST_MODIFICATION } from '../../../shared/constants';

@Component({
    selector: 'qms-faculty-details',
    templateUrl: './faculty-details.component.html'
})
export class FacultyDetailsComponent implements OnInit, OnDestroy {
    public faculty: Faculty;

    private routerSubscription: Subscription;
    private eventSubscription: Subscription;

    constructor(private route: ActivatedRoute,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private dataUtils: JhiDataUtils,
                private facultyService: FacultyService) {
    }

    ngOnInit() {
        this.routerSubscription = this.route.params.subscribe((params) => {
            ParamUtils.parseNumber(params['id'], (facultyId: number) => {
                this.load(facultyId);
            }, () => {
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
                this.previousState();
            });
        });
        this.registerChangeInFaculties();
    }

    public getLogo(faculty: Faculty) {
        return FileUtils.getImageBase64Format(faculty.logo, faculty.logoContentType);
    }

    public loadLogo(faculty: Faculty) {
        return this.dataUtils.openFile(faculty.logoContentType, faculty.logo);
    }

    public previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscription);
    }

    private load(id: number) {
        this.facultyService.find(id).subscribe((faculty: Faculty) => {
            this.faculty = faculty;
        }, () => {
            this.previousState();
        });
    }

    private registerChangeInFaculties() {
        this.eventSubscription = this.eventManager.subscribe(
            FACULTY_LIST_MODIFICATION, (response) => {
                if (!this.wasDeleted(response)) {
                    this.load(this.faculty.id);
                }
            }
        );
    }

    private wasDeleted(response: any): boolean {
        if (response.content && response.content === 'Deleted') {
            if (response.modelId && response.modelId === this.faculty.id) {
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/faculties/faculty-details.component.ts